import Vue from 'vue'
import App from './App.vue'
import 'es6-promise/auto'
import Mint from 'mint-ui'
import moment from 'moment'

import router from './router'
import store from './store'
import utils from './util/util'

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

import 'mint-ui/lib/style.css'
import './assets/style/iconfont/iconfont.css'
import './assets/style/common.scss'

// i18
import VueI18n from 'vue-i18n'
import i18n from './lang/index'
// copy
import VueClipboard from 'vue-clipboard2'

import { Image as VanImage } from 'vant';
import { Lazyload } from 'vant';
import 'vant/lib/image/style';
Vue.use(Lazyload);
Vue.use(VanImage);

Vue.use(VueClipboard)

Vue.use(VueAwesomeSwiper, /* { default options with global component } */);

Vue.use(Mint)
// import no_image from './assets/image/no_image.jpg'
// Vue.use(Mint, {
//   lazyload: {
//     loading: no_image,
//     attempt: 0,
//   },
// });


Vue.prototype.utils = utils;

moment.locale('zh-cn')
Vue.prototype.$moment = moment
Vue.config.productionTip = false

new Vue({
  VueI18n,
  i18n,
  store,
  router,
  render: h => h(App),
}).$mount('#app')
// new Vue({
//     el: '#app',
//     store,
//     router,
//     components: { App },
//     template: '<App/>'
// })
